import type { WindowState } from "../../context/WindowManagerContext";

interface WindowSwitcherProps {
  windows: WindowState[];
  activeId: string | null;
  highlightId: string | null;
}

export function WindowSwitcher({ windows, activeId, highlightId }: WindowSwitcherProps) {
  if (windows.length === 0) return null;

  return (
    <div className="wm-switcher">
      <div className="wm-switcher__list">
        {windows.map((win) => (
          <div
            key={win.id}
            className={`wm-switcher__item ${win.id === highlightId ? "wm-switcher__item--active" : ""}`}
          >
            <div className="wm-switcher__icon">
              {win.icon && (
                <svg viewBox="0 0 24 24">
                  <path d={win.icon} />
                </svg>
              )}
            </div>
            <span className="wm-switcher__title">{win.title}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
